import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { TrackerIntegrationValidationSchema } from '../../schemas/trackerIntegrations/create.schema'

interface UseCreateTrackerIntegrationProps {
  companyId: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateTrackerIntegration = ({ companyId, onSuccess, onError }: UseCreateTrackerIntegrationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createTrackerIntegration'],
    mutationFn: async (form: TrackerIntegrationValidationSchema) => {
      const tracker_integration = {
        ...form,
        company_id: companyId,
        option_id: form?.option_id?.value,
      }

      return privateAxios.post('/client/tracker_integrations', {tracker_integration})
    },
    onSuccess,
    onError,
  })
}

export default useCreateTrackerIntegration
